import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header"; // Importe o Header
import Home from "./Home";
import About from "./pages/About";
import ProjectsPage from "./pages/Projects"; // Nova página para Projects
import News from "./pages/News";
import Contact from "./pages/Contact";
import Footer from "./components/Footer"
import BlogPostPage from "./pages/BlogPostPage";
import ScrollToTop from "./components/ScrollToTop";
import BlogList from "./pages/BlogList";
import WhatsappButton from "./components/WhatsappButton";

import "./assets/common/fonts.css"
import "./styles/global.css"; // Importando o CSS global


const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header /> {/* Header incluído aqui */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<ProjectsPage />} /> 
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<BlogList />} />

        <Route path="/blog/:slug" element={<BlogPostPage />} />
      </Routes>
      {/* Botão do WhatsApp */}
        <WhatsappButton
          phoneNumber="+551198835125"
          message="Olá! Vim através do site e gostaria de mais informações."
        />
      <Footer/>
    </Router>
  );
};

export default App; 